import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../shared/app-settings';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class RestService {
  // currentUser: any;
  constructor(public http: HttpClient,
    public authService: AuthenticationService,
    ) {
      
    }
  getRequest(url, obj?): Observable<any> {
    const httpOptions: { params?: Record<string, string> | HttpParams } = {};
    if (obj != null && obj !== '') {
      httpOptions.params = obj;
    }
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}`, httpOptions);
  }

  getRequestPagination(url, id): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}${id}`);
  }

  getSortingItems(url, pageNumb, col, sort): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}${pageNumb}&sort=${col},${sort}`)
  }

  getMonitorSortingItems(url, pageNumb, col, sort): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}${pageNumb}&sort=${col},${sort}`)
  }

  getSitesSearchItes(url, searchKey): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}${searchKey}${AppSettings.DASHBOARDSITESSEARCHASC}`);
  }

  getMonitorsSearchItes(url, searchKey): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}${searchKey}`);
  }

  getSitesByStatus(val): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/dashboard/sites?status=${val}&page=&sort=&siteName=`);
  }

  getSitesByStatusAndPage(val, page, sitename): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/dashboard/sites?status=${sitename}&page=${page}&sort=&siteName=${val}`);
  }

  getSitesBySearchAndPage(val, page, sitename): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/dashboard/sites/all?page=${page}&sort=&siteName=${val}`);
  }

  getMonitorsByStatus(val): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${AppSettings.DASHBOARDMONITORSBYSTATUS}${val}`);
  }

  getMonitorsByStatusAndPage(val, page): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${AppSettings.DASHBOARDMONITORSBYSTATUS}${val}&page=${page}`);
  }

  getMonitorsByFilter(url): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}`);
  }

  getSites(url): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}`);
  }

  getData(url): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}`);
  }

  getWeather(url): Observable<any> {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}`);
  }

  getAppserver(url):Observable<any>{
    return this.http.get(`${url}`);
  }

  postRequest(url, params): Observable<any> {
    return this.http.post(`${AppSettings.API_ENDPOINT}/${url}`, params);
  }

  public downloadReport(url, body): Observable<any> {
    return this.http.post(`${AppSettings.API_ENDPOINT}/${url}`, { responseType: 'blob' });
  }

  deleteRequest(url, params) {
    return this.http.delete(`${AppSettings.API_ENDPOINT}/${url}/${params}`);
  }
  deleteRole(url, params) {
    return this.http.delete(`${AppSettings.API_ENDPOINT}/${url}${params}`);
  }
  deleteUser(url, params) {
    return this.http.delete(`${AppSettings.API_ENDPOINT}/${url}${params}`);
  }
  getMetrics(url) {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}`);
  }

  getHealthMonitoringData(url) {
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}`);
  }

  getcpuUsage(url){
    return this.http.get(`${AppSettings.API_ENDPOINT}/${url}`);
  }

  getRamUsage(url){
     return this.http.get(`${AppSettings.API_ENDPOINT}/${url}`);
  }

  deleteprevilege(url, id) {
    // http://meadmin.pro-vigil.uk:9050/api
    // 'privilege/delete'
    // 'http://meadmin.pro-vigil.uk:9050/api/privilege/delete?privilegeId=3'
    //"http://meadmin.pro-vigil.uk:9050/api/privilege/delete?privilegeId=2"
    let deleteurl = `${AppSettings.API_ENDPOINT}/${url}` + `?privilegeId=` + id
    return this.http.delete(deleteurl);
  }

  putRequest(url, params) {
    return this.http.put(`${AppSettings.API_ENDPOINT}/${url}`, params);
  }

  downloadFile(data, filename = 'data') {
    let csvData = this.ConvertToCSV(data, ['UniqueCameraId', 'CameraName', 'HDUrl']);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  downloadX310X410Data(data, filename) {
    let csvData = this.ConvertToCSV(data, ['potentialId', 'siteName', 'type', 'status', 'solarState', 'lineVoltage', 'batteryVoltage', 'encoder', 'realy2', 'siren', 'router', 'temperature', 'reason', 'devDate']);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  downloadMdcData(data, filename) {
    let csvData = this.ConvertToCSVmdc(data, ['potentialId', 'siteName', 'type', 'deviceName', 'siteType', 'status', 'siteUnitId', 'solarEnabled', 'deviceId', 'deviceUqId', 'deviceType', 'accId']);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  downloadactiveAxis(data, filename) {
    let csvData = this.ConvertToCSVAxis(data, ['prodShortName','wdr','irCutFilter','maxShutter','maxGain','lowNoise','exposureLevel','resolution','frameRate','compression','zipStream','bitrateControl','date','clock','timeZone','ntpServer','dhcpServer','timesSyncSource','aid7Details','screenProfileAID7','sdCard','storageLimit','recordings','prodFullName','httpsPort','hostName','ipAddress','macAddress','firmwareManagementVersion','systemBoaPort','cameraUniqueld','buildDate','buildNumber','firmwareVersion','fps','height','ir','serialNumber','width','exposureValue','pframes','pcount']);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = "Potential Id,Site Name,Type,Status,Solar State,Line Voltage,Battery Voltage,Encoder,Relay2,Siren,Router,Temperature,Reason,Device Time";

    // for (let index in headerList) {
    //   row += headerList[index] + ',';
    // }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in headerList) {
        let head = headerList[index];

        line += ((typeof (array[i][head]) === 'string') ? array[i][head].replace(',', ' ') : array[i][head]) + ',';
      }
      str += line + '\r\n';
    }
    return str;
  }

  ConvertToCSVmdc(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = "Potential Id,Site Name,Type,Device Name,Site Type,Status,Site UnitId,Solar Enabled,Device Id,Device Unique Id,Device Type,AccId";

    // for (let index in headerList) {
    //   row += headerList[index] + ',';
    // }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in headerList) {
        let head = headerList[index];

        line += ((typeof (array[i][head]) === 'string') ? array[i][head].replace(',', ' ') : array[i][head]) + ',';
      }
      str += line + '\r\n';
    }
    return str;
  }

  ConvertToCSVAxis(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = "Prod Short Name,WDR,IR CutFilter,Max Shutter,Max Gain,Low Noise,Exposure Level,Resolution,Frame Rate,Compression,Zip Stream,Bitrate Control,Date,Clock,Time Zone,NTP Server,DHCP Server,Times SyncSource,AID7 Details,Screen Profile AID7,SD Card,Storage Limit,Recordings,Prod Full Name,HTTPS Port,Host Name,IP Address,MAC Address,Firmware Management Version,System Boa Port,Camera Uniqueld,Build Date,Build Number,FirmwareVersion,FPS,Height,IR,Serial Number,Width,Exposure Value,PFrames,PCount";
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in headerList) {
        let head = headerList[index];
        line += ((typeof (array[i][head]) === 'string') ? array[i][head].replace(/,/g, ' ') : array[i][head]) + ',';
      }
      str += line + '\r\n';
    }
    return str;
  }

  setSelectedSiteObj(siteData,gafanaData){
    localStorage.setItem('selectedSiteObj',JSON.stringify({
      site:siteData,
      gafana: gafanaData
    }));
  }
}

